import { Button, InputNumber, Space, Tooltip } from "antd";

export const OverrideDatapointField = ({
  metric,
  value,
  handleChange,
  fillWithAverage,
  revertChange,
  avg,
  type,
  metricIdentifier
}) => {
  return (
    <div className="team-settings-input-wrap">
      <div className="team-settings-input-label">{metric["name"]}:</div>
      <Space.Compact>
        <InputNumber
          type="number"
          min="0"
          step="1"
          id={metric["key"]}
          name={metric["key"]}
          value={value}
          className="team-settings-input-stick"
          onChange={handleChange}
        />
        <Tooltip title="Fill with team average value">
          <Button
            className="team-settings-button"
            onClick={() => fillWithAverage("team_avg")(type=='testing' ? metric["name"] : metric["key"], metricIdentifier)}
          >
            Team Avg: {(avg?.team_avg?.[type=='testing' ? metric["name"] : metric["key"]] || 0).toFixed(2)}
          </Button>
        </Tooltip>
        <Tooltip title="Fill with position average value">
          <Button
            className="team-settings-button"
            onClick={() => fillWithAverage("pos_avg")(type=='testing' ? metric["name"] : metric["key"], metricIdentifier)}
          >
            Pos Avg: {(avg?.pos_avg?.[type=='testing' ? metric["name"] : metric["key"]] || 0).toFixed(2)}
          </Button>
        </Tooltip>
        <Tooltip title="Undo the change">
          <Button
            className="team-settings-button"
            onClick={() => revertChange(metric["key"], metricIdentifier)}
          >
            Undo
          </Button>
        </Tooltip>
      </Space.Compact>
    </div>
  );
};
